import { useEffect, useState } from "react";
import { X } from "lucide-react";

export const ActionModal = ({ open, title, description, confirmLabel, tone = "primary", fields = [], onClose, onConfirm, busy, error, notice }) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    if (open) setValues(Object.fromEntries(fields.map((field) => [field.name, field.defaultValue ?? (field.type === "checkbox" ? false : "")])));
  }, [open, fields]);

  if (!open) return null;
  const valid = fields.every((field) => {
    const required = typeof field.requiredWhen === "function" ? field.requiredWhen(values) : field.required;
    return !required || (field.type === "checkbox" ? Boolean(values[field.name]) : String(values[field.name] || "").trim());
  });

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose} data-testid="action-modal-backdrop">
      <section className="action-modal" role="dialog" aria-modal="true" aria-labelledby="action-modal-title" onMouseDown={(event) => event.stopPropagation()} data-testid="action-modal">
        <div className="modal-heading">
          <div><span className="overline">Confirmation required</span><h2 id="action-modal-title">{title}</h2></div>
          <button className="icon-button" onClick={onClose} aria-label="Close dialog" data-testid="action-modal-close-button"><X size={18} /></button>
        </div>
        <p className="modal-description" data-testid="action-modal-description">{description}</p>
        {notice && <div className="modal-notice" data-testid="action-modal-notice">{notice}</div>}
        {error && <div className="modal-error" role="alert" data-testid="action-modal-error">{error}</div>}
        <div className="modal-fields">
          {fields.map((field) => (
            <label key={field.name} htmlFor={`modal-${field.name}`} className={field.type === "checkbox" ? "checkbox-field" : ""}>
              <span>{field.label}</span>
              {field.type === "select" ? (
                <select id={`modal-${field.name}`} value={values[field.name] || ""} onChange={(e) => setValues({ ...values, [field.name]: e.target.value })} data-testid={`action-modal-${field.name}-select`}>
                  {field.options.map((option) => <option key={option.value ?? option} value={option.value ?? option}>{option.label ?? option}</option>)}
                </select>
              ) : field.type === "checkbox" ? (
                <input id={`modal-${field.name}`} type="checkbox" checked={Boolean(values[field.name])} onChange={(e) => setValues({ ...values, [field.name]: e.target.checked })} data-testid={`action-modal-${field.name}-checkbox`} />
              ) : field.type === "text" || field.type === "number" ? (
                <input id={`modal-${field.name}`} type={field.type} min={field.min} max={field.max} step={field.step} placeholder={field.placeholder} value={values[field.name] || ""} onChange={(e) => setValues({ ...values, [field.name]: e.target.value })} data-testid={`action-modal-${field.name}-input`} />
              ) : (
                <textarea id={`modal-${field.name}`} rows="3" placeholder={field.placeholder} value={values[field.name] || ""} onChange={(e) => setValues({ ...values, [field.name]: e.target.value })} data-testid={`action-modal-${field.name}-input`} />
              )}
            </label>
          ))}
        </div>
        <div className="modal-actions">
          <button className="button secondary" onClick={onClose} disabled={busy} data-testid="action-modal-cancel-button">Cancel</button>
          <button className={`button ${tone}`} onClick={() => onConfirm(values)} disabled={!valid || busy} data-testid="action-modal-confirm-button">{busy ? "Working…" : confirmLabel}</button>
        </div>
      </section>
    </div>
  );
};